import { render, staticRenderFns } from "./ToolbarBlock.vue?vue&type=template&id=e8b1f784&scoped=true&"
import script from "./ToolbarBlock.vue?vue&type=script&lang=js&"
export * from "./ToolbarBlock.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarBlock.vue?vue&type=style&index=0&id=e8b1f784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b1f784",
  null
  
)

export default component.exports